var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlumbingAlt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 44 44",
    style: {
      enableBackground: "new 0 0 44 44"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{fill:none;stroke:#BBC0CF;stroke-width:2;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      display: "inline",
      overflow: "visible"
    },
    width: 1378,
    height: 1112,
    xlinkHref: "../../Screen Shot 2022-12-05 at 12.30.14 PM.png",
    transform: "matrix(2.503341e-02 0 0 2.503341e-02 5.6667 9.1231)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.6,17.9c0,0-1.6-0.2-3.3,1.4c-1.2,1.1-1.5,2.5-1.5,2.5l-0.2,4.2c-0.3,2-2.6,2.2-2.6,2.2 c-3,0-3.1-2.4-3.1-2.4v-6.9l0-3.2l-5.3,0.1v4.9c0,5.8,0,5.9,0.1,6.3l0,0v0c0.2,1,0.6,2,1.1,2.7h0c1,1.7,2.7,3,4.5,3.6 c0.8,0.3,1.4,0.4,2.2,0.4c3.6,0.2,7-2.1,8.2-5.5c0.3-0.8,0.4-1.4,0.4-2.6l0-1.1l0-1l1,0l2.8,0l1.7,0l0-5.4L26.6,17.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.2,
    y: 12,
    className: "st1",
    width: 9.9,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.7,
    y: 15.7,
    className: "st1",
    width: 3.5,
    height: 9.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlumbingAlt);
export default __webpack_public_path__ + "static/media/PlumbingAlt.b5d30337c7331e79490797d43813bd6f.svg";
export { ForwardRef as ReactComponent };